/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description InsuranceActions
 */
import { Dropdown } from 'antd';
import { MoreOne } from '@icon-park/react';
import { MenuItemType } from 'antd/es/menu/interface';
import Button from '.';
import { defaultDropdownButtonProps } from './ClaimTableActions';

export interface InsuranceActionsProps {
	coverageId: string;
	versionId: string;
}

const InsuranceActions: React.FC<InsuranceActionsProps> = ({ coverageId, versionId }) => {
	const schema: MenuItemType[] = [
		{
			key: 'move',
			className: 'tw-dropdown-menu-item',
			danger: true,
			label: <Button.MoveToPreviousInsurance coverageId={coverageId} versionId={versionId} {...defaultDropdownButtonProps} />,
		},
	];

	return (
		<Dropdown menu={{ items: schema }} trigger={['click']}>
			<Button color='default' icon={<MoreOne />} onClick={(e) => e.stopPropagation()} />
		</Dropdown>
	);
};

export default InsuranceActions;
